<template>
  <a-modal
    :title="setArchiveTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :width="$isEnglish ? 630 : 604"
    :mask-closable="false"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    class="archive-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div
      class="archieve-tip"
      :class="{'archive-tip-english': $isEnglish}"
    >
      {{ $t('message["1777"]') }}
    </div>
    <a-form
      :form="form"
      class="archieve-form"
    >
      <a-form-item
        :label="$t('message[1977]')"
        class="archive-reason"
      >
        <a-input
          v-decorator="['reason', { initialValue: '' }]"
          :placeholder="$t('message[1978]')"
          type="textarea"
        />
      </a-form-item>
      <a-form-item :label="archiveTit">
        <a-checkbox-group
          v-decorator="['resettype', { initialValue: [] }]"
          style="width: 100%;"
          @change="changeValue"
        >
          <a-checkbox
            v-for="item in archiveTypesData"
            :key="item.id"
            :disabled="item.disabled"
            :value="item.id"
          >
            {{ item.name }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  props: {
    successBackRoute: {
      type: Function,
      default: () => { }
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['archiveTypesData']),
    setArchiveTit () {
      return this.$t('message["1776"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    archiveTit () {
      return this.$t('message["1775"]')
    }
  },
  watch: {
    visible (val) {
      if (val) {

      }
    }
  },
  methods: {
    moment,
    ...mapActions('inquery/detailData', ['archiveInquiry']),
    showHide (b) {
      // this.$emit('update:visible', false)
      this.visible = b
    },
    changeValue (val) {
      if (val.includes(2)) {
        this.setDiasbled(3)
      } else if (val.includes(3)) {
        this.setDiasbled(2)
      } else {
        this.setDiasbled()
      }
      // this.date = date
    },
    setDiasbled (key) {
      for (let i = 0; i < this.archiveTypesData.length; i++) {
        const item = this.archiveTypesData[i]
        if (item.id === key) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      }
    },
    async handleOk () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          if (this.confirmLoading) return

          this.confirmLoading = true
          console.log(values)

          const chain = await this.archiveInquiry()
          chain
            .onSuccess((raw, res) => {
              if (!res.error) {
                this.visible = false
                this.successBackRoute()
              }
            })
            .params({
              ...values,
              inquiryid: this.inquiryId
            })
            .fetch()
        }
      })
    },
    handleCancel () {
      this.showHide(false)
      this.form.resetFields()
    },
    handleCloseTime () {
      this.timeOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.archieve-form::v-deep {
  .archive-reason{
    display: flex;
    .ant-form-item-control-wrapper{
      width: 75%;
      .ant-input{
         width: 400px;
        height: 100px;
      }
    }
  }
  .ant-checkbox-wrapper {
    margin-right: 16px;
  }
  .ant-checkbox-wrapper:last-child {
    margin-right: 0;
  }
}
.archieve-tip {
  margin: 0 -40px 28px;
  padding: 0 24px;
  background: #FFF4E7;
  height: 40px;
  line-height: 40px;
  color: #424242;
}
.archive-tip-english {
  line-height: 20px;
  height: auto;
  padding: 8px 24px;
}
</style>
<style lang="scss">
.archive-modal {
  .ant-modal-body {
    padding: 0 40px;
  }
}
</style>
